<template>
    <placement>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :fields="fields" :items="companies" :action="{'text':'add Company','url':route('placement.company.create')}" :searchlink="route('placement.company.search')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Company')" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Company')">
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
                
                <template #action="data">
                    <button-link :href="route('placement.company.edit',data.item.id)" v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Company')">Edit</button-link>
                </template>
            </breeze-table>
        </div>
    </placement>
</template>

<script>
    import Placement from '@/Pages/Placement/Placement'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Placement,
            BreezeTable,
            ButtonLink
        },
        props:['companies'],
        data(){
            return{
                fields:this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Company')?[{'key':'name','label':'Name'},{'key':'first_person_name','label':'Person Name'},{'key':'first_person_mobile','label':'Person Mobile'},{'key':'first_person_email','label':'Person Email'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}]:[{'key':'name','label':'Name'},{'key':'first_person_name','label':'Person Name'},{'key':'first_person_mobile','label':'Person Mobile'},{'key':'first_person_email','label':'Person Email'}]
            }
        }
    }
</script>
